import script from "./user-message.vue?vue&type=script&setup=true&lang=js"
export * from "./user-message.vue?vue&type=script&setup=true&lang=js"

import "./user-message.vue?vue&type=style&index=0&id=d892ba5c&lang=scss&scoped=true"
import "./user-message.vue?vue&type=style&index=1&id=d892ba5c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d892ba5c"]])

export default __exports__